var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-menu",
    { attrs: { "default-active": _vm.activeMenu, "unique-opened": true } },
    _vm._l(_vm.navTree, function (item) {
      return _c("menu-tree-item", { key: item.id, attrs: { menu: item } })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }